import { getDraft } from '@/redux/draft/getters/getDraft';
import { StoreState } from '@/redux/types';

export function isDraftValid(state: StoreState) {
  return getDraft(state).validation.valid;
}
